<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Clear Page" icon="🗑" color="#2563eb">
        <label>Page</label>
        <select :value="props.data.page" @change="update('page', $event.target.value)">
            <option value="all">All pages</option>
            <option v-for="p in pages" :key="p.id" :value="String(p.id)">{{ p.label }}</option>
        </select>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { inject, computed } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const haspObjects = inject('haspObjects', null);

const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
const pages = computed(() => haspObjects?.pages?.value ?? []);
</script>
